/**
 * Orthotic "intended use" options — the single source of truth for both the
 * PatientForm select and the prescription Excel export. Kept in a plain module
 * (no React) so the data exporter can reuse it without importing a form
 * component.
 */
export type OrthoticIntendedUse =
  | 'sports'
  | 'stability'
  | 'everyday_comfort'
  | 'dress_low_profile'
  | 'ucbl_kids'
  | 'emirates_cabin_crew';

export const ORTHOTIC_INTENDED_USE_OPTIONS: ReadonlyArray<{
  value: OrthoticIntendedUse;
  label: string;
}> = [
  { value: 'sports', label: 'Sports orthotics' },
  { value: 'stability', label: 'Stability orthotics' },
  { value: 'everyday_comfort', label: 'Everyday comfort' },
  { value: 'dress_low_profile', label: 'Dress / Low profile' },
  { value: 'ucbl_kids', label: 'UCBL orthotics (only for kids)' },
  { value: 'emirates_cabin_crew', label: 'Emirates Cabin Crew' },
];
